import { put, call, takeLatest } from 'redux-saga/effects'
import {
  REQUEST_ADDRESS_DATA
} from '../constants/addressConstant'
import {
  setAddressData,
  setAddressState,
} from '../actions/addressAction'

function * requestAddressData () {
  yield put(setAddressState({ loading: true, invalid: false }))
  let request = () => window.axios
    .request({ url: window.API.Address.getList })
  try {
    let data = yield call(request)
    yield put(setAddressData(data))
  } catch (error) {
    yield put(setAddressState({ loading: false, invalid: true, errorMessage: error.message }))
  }
}

export function addressSaga () {
  return takeLatest(REQUEST_ADDRESS_DATA, requestAddressData)
}
